import * as React from 'react';
import { Radio, RadioGroup, TextField } from '@cimpress/react-components';
import { ArtworkUrlType } from './types';
import debounce from 'debounce';
import { useDoubleTTranslation } from '../hooks/i18n';
export const UrlArtworkSelector = ({ language, onChange, currentSelectorState }) => {
    const currentSelectionEntry = Object.entries(currentSelectorState || {}).find(e => e[1] !== undefined);
    const [artworkUrlType, setArtworkUrlType] = React.useState(currentSelectionEntry ? currentSelectionEntry[0] : ArtworkUrlType.DocumentReferenceUrl);
    const { tt } = useDoubleTTranslation(language);
    const [url, setUrl] = React.useState(currentSelectionEntry ? currentSelectionEntry[1] : undefined);
    const debouncedOnChange = React.useRef(_x => {
    });
    React.useEffect(() => {
        debouncedOnChange.current = debounce(onChange, 150);
    }, [onChange]);
    React.useEffect(() => {
        if (!artworkUrlType) {
            return;
        }
        debouncedOnChange.current(url ? { [artworkUrlType]: url } : undefined);
    }, [url, artworkUrlType]);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", null,
            React.createElement(RadioGroup, { onChange: e => {
                    setArtworkUrlType(e.target.value);
                    setUrl(undefined);
                }, inline: true, defaultSelected: artworkUrlType, name: "artworkUrlType" },
                React.createElement(Radio, { label: tt('urlArtworkSelector.docRefUrl'), value: ArtworkUrlType.DocumentReferenceUrl }),
                React.createElement(Radio, { label: tt('urlArtworkSelector.manufacturingReadyUrl'), value: ArtworkUrlType.ManufacturingReadyDataUrl })),
            React.createElement(TextField, { required: true, name: "url", id: "url", value: url, label: tt('urlArtworkSelector.provideUrl'), autoFocus: true, type: "url", onChange: e => setUrl(e.target.value) }))));
};
//# sourceMappingURL=UrlArtworkSelector.js.map